var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDhl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 18,
    viewBox: "0 0 126 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_68829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.6504H15.278L14.4 17.9104H0V16.6504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 17.9104H107.298L108.264 16.6504H126.088V17.9104H126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.3105H17.0341L16.0683 15.5705H0V14.3105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.9697H18.7902L17.8244 13.2297H0V11.9697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126 15.5705H109.054L110.02 14.3105H126.088V15.5705H126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.688 11.9697H126V13.2297H110.722L111.688 11.9697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5068 17.9098L24.5849 6.83984C24.5849 6.83984 33.541 6.83984 34.5946 6.83984C35.7361 6.83984 35.7361 7.28984 35.1215 8.00984C34.5946 8.72984 33.6288 10.0798 33.102 10.7998C32.8385 11.2498 32.3117 11.8798 33.98 11.8798C35.8239 11.8798 47.4142 11.8798 47.4142 11.8798C46.3605 13.4998 42.6727 17.9998 36.1751 17.9998C30.9068 17.9098 16.5068 17.9098 16.5068 17.9098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7804 11.9697L58.3901 17.9997H46.8877L51.2779 11.9697H62.7804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5508 11.9697L75.1606 17.9997H63.5703L67.9606 11.9697H79.5508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3266 11.9697C83.3266 11.9697 82.4486 13.1397 82.0974 13.6797C80.6047 15.6597 81.9218 17.9997 86.6632 17.9997C92.1071 17.9997 105.278 17.9997 105.278 17.9997L109.668 11.9697H83.3266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2148 0.000156246L18.1758 5.49016C18.1758 5.49016 38.9855 5.49016 40.127 5.49016C41.2685 5.49016 41.2685 5.94016 40.6538 6.66016C40.127 7.38016 39.1611 8.73016 38.6343 9.45016C38.3709 9.81016 37.8441 10.5302 39.5124 10.5302C41.3563 10.5302 48.4685 10.5302 48.4685 10.5302C48.4685 10.5302 49.9611 8.55016 51.1026 6.84016C52.7709 4.59016 51.2782 -0.0898438 45.3953 -0.0898438C40.127 0.000156246 22.2148 0.000156246 22.2148 0.000156246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5173 10.53H52.2441L59.971 0H71.5612L67.171 6.03H72.3515L76.7417 0H88.3319L80.5173 10.53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.312 0L96.5857 10.53H84.293L92.0198 0H104.312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_68829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhl);
export default __webpack_public_path__ + "static/media/DHL.1f263b7bb3baf7a5a3528d01a588566e.svg";
export { ForwardRef as ReactComponent };